import { render, staticRenderFns } from "./gong.vue?vue&type=template&id=44d07c1e&scoped=true&"
import script from "./gong.vue?vue&type=script&lang=js&"
export * from "./gong.vue?vue&type=script&lang=js&"
import style0 from "./gong.vue?vue&type=style&index=0&id=44d07c1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d07c1e",
  null
  
)

export default component.exports